import { render, staticRenderFns } from "./loanCard.vue?vue&type=template&id=a01bcdd2&scoped=true"
import script from "./loanCard.vue?vue&type=script&lang=js"
export * from "./loanCard.vue?vue&type=script&lang=js"
import style0 from "./loanCard.vue?vue&type=style&index=0&id=a01bcdd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01bcdd2",
  null
  
)

export default component.exports